import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useMultiExpConfig } from "../../context/MultiExpConfigProvider";
import DynamicBottomBar from "../../components/DynamicBottomBar";
import CameraApp from "./CameraApp";
import Video from "./Video";
import Images from "./Image";
import ModelViewer from "./ModelViewer";
import DynamicIconGroup from "../../components/DynamicIconGroup";
import { NewLoader } from "../../components/NewLoader";
import "./ModelViewer.css";
import SnapCamera from "./SnapCamera";
import { filterValidUrlFormats } from "../../utils/urlValidator";

function SwipeLeftOverlay() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div id="arrowAnim" className="swipe-overlay">
      <div className="arrowSliding">
        <div className="arrow"></div>
      </div>
      <div className="arrowSliding delay1">
        <div className="arrow"></div>
      </div>
      <div className="arrowSliding delay2">
        <div className="arrow"></div>
      </div>
      <div className="arrowSliding delay3">
        <div className="arrow"></div>
      </div>
    </div>
  );
}

function MultiExp() {
  const [searchParams] = useSearchParams();
  const testParam = searchParams.get("exp");
  const [customerKey, ocId, batchId, brandId] = testParam
    ? testParam.split("x")
    : [];
  const [icons, setIcons] = useState([]);
  const [showFirstParty, setShowFirstParty] = useState(false);

  const { fetchMultiExpConfig, multiExpConfig, loading, error } =
    useMultiExpConfig();

  useEffect(() => {
    if (customerKey && batchId && brandId) {
      fetchMultiExpConfig(customerKey, batchId, brandId);
    }
  }, [customerKey, batchId, brandId, fetchMultiExpConfig]);

  useEffect(() => {
    const iconsList = [
      {
        image: multiExpConfig?.model?.chatbot?.cfield1 || "",
        alt: "icon",
        onClick: () =>
          window.open(
            multiExpConfig?.model?.chatbot?.cfield2 || "https://fiduciaai.com"
          ),
      },
      {
        image: multiExpConfig?.model?.chatbot?.cfield3 || "",
        alt: "icon",
        onClick: () =>
          window.open(
            multiExpConfig?.model?.chatbot?.cfield4 || "https://fiduciaai.com"
          ),
      },
      {
        image: multiExpConfig?.model?.chatbot?.cfield5 || "",
        alt: "icon",
        onClick: () =>
          window.open(
            multiExpConfig?.model?.chatbot?.cfield6 || "https://fiduciaai.com"
          ),
      },
      {
        image: multiExpConfig?.model?.chatbot?.cfield7 || "",
        alt: "icon",
        onClick: () =>
          window.open(
            multiExpConfig?.model?.chatbot?.cfield8 || "https://fiduciaai.com"
          ),
      },
      {
        image: multiExpConfig?.model?.chatbot?.cfield9 || "",
        alt: "icon",
        onClick: () =>
          window.open(
            multiExpConfig?.model?.chatbot?.cfield10 || "https://fiduciaai.com"
          ),
      },
    ];

    setIcons(iconsList);
  }, [multiExpConfig]);

  console.debug("MultiExp config Object: ", multiExpConfig);

  const validVideos = filterValidUrlFormats(
    multiExpConfig?.model?.videos?.video || []
  );
  const validImages = filterValidUrlFormats(
    multiExpConfig?.model?.pictures?.picture || []
  );
  const validModels = filterValidUrlFormats(
    multiExpConfig?.model?.models?.model || []
  );

  const tabs = [
    {
      key: "chatbot",
      label: "SpeedShot",
      component: (
        <CameraApp
          showBottomBar={false}
          config={multiExpConfig?.model?.chatbot}
          multiExp={true}
          cKey={customerKey}
          oId={ocId}
          onFirstPartyToggle={setShowFirstParty}
        />
      ),
    },
    ...(validVideos.length > 0
      ? [
        {
          key: "videos",
          label: "Videos",
          component: <Video showRoboIcon={false} videos={validVideos} captureEnabled={multiExpConfig?.model?.chatbot?.captureOtherTabsEnabled ?? false} />,
        },
      ]
      : []),
    ...(validImages.length > 0
      ? [
        {
          key: "pictures",
          label: "Pictures",
          component: <Images showRoboIcon={false} images={validImages} />,
        },
      ]
      : []),

    ...(validModels.length > 0
      ? [
        {
          key: "models",
          label: "3D",
          component: <ModelViewer modelUrls={validModels} />,
        },
      ]
      : []),

    // snapCamera goes here - only render if multiExpConfig contains required properties
    ...(multiExpConfig?.model?.snapar?.groupid ||
      multiExpConfig?.model?.snapar?.defaultlens
      ? [
        {
          key: "snapCamera",
          label: "Snap Camera",
          component: (
            <SnapCamera
              groupid={multiExpConfig?.model?.snapar?.groupid}
              lensid={multiExpConfig?.model?.snapar?.defaultlens}
            />
          ),
        },
      ]
      : []),
  ];

  const preferenceOrderString =
    multiExpConfig?.preferenceOrder ||
    "chatbot,videos,pictures,models,snapCamera";
  const preferenceOrder = preferenceOrderString.split(",").map((s) => s.trim());
  const tabMap = tabs.reduce((map, tab) => {
    map[tab.key] = tab;
    return map;
  }, {});
  const orderedTabs = preferenceOrder.map((key) => tabMap[key]).filter(Boolean);

  if (loading) {
    return (
      <div>
        <NewLoader />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      {/* conditionally render dynamic icon group  */}
      {!showFirstParty && <DynamicIconGroup icons={icons} />}

      <SwipeLeftOverlay />
      {/* make this div height 100dvh fallback to 100vh */}
      <div style={{ height: "100dvh", height: "100vh" }}>
        <DynamicBottomBar tabs={orderedTabs} isFormOpen={showFirstParty} />
      </div>
    </>
  );
}

export default MultiExp;
